import { render } from "./EjwFaq.vue?vue&type=template&id=07d77e7c"
import script from "./EjwFaq.vue?vue&type=script&lang=js"
export * from "./EjwFaq.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/www/releases/20260911022515/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__